import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import _ from 'lodash';

import PopupContents from './map-popup-contents';
import MapMarker from './map-marker';
import definePopupClass from './map-popup-factory';
import { getMapLinkForLocation, getMapBounds, getCenterOffset } from '../utils/data/location-toolbox';
import { I18N, API_KEY } from '../globals/wp';
import styles from './map.pcss';
import PropTypes from "prop-types";

let Popup; // Popup Class definition
const K_BOUNDS_PADDING = {
	top: 55,
	left: 25,
	right: 25,
	bottom: 25,
};

// US by default
const defaultProps = {
	center: {
		lat: 40.2309152,
		lng: -105.7533084,
	},
	zoom: 5,
};

const mapRef = React.createRef();

class Map extends Component {

	static propTypes = {
		locations: PropTypes.array.isRequired,
	};

	constructor(props) {
		super(props);
		this.mapInstance = undefined;
		this.googleMaps = undefined; // loaded google.maps instance
		this.currentPopup = undefined;

		this.state = {
			locations: props.locations,
		};
	}

	removePopup = () => {
		if (this.currentPopup) {
			this.currentPopup.setMap(null);
			this.currentPopup = undefined;
		}
	};

	bindMapListeners = (map, maps, bounds) => {
		// resize
		maps.event.addDomListenerOnce(map, 'idle', () => {
			maps.event.addDomListener(window, 'resize', () => {
				map.setOptions({
					maxZoom: 13,
				});
				map.fitBounds(bounds);
				map.setOptions({
					maxZoom: 999,
				});
			});
		});
		// remove popup on click ()
		maps.event.addDomListener(map, 'click', (e) => {
			this.removePopup();
		});
	};

	center = (map, maps, locations) => {
		map.setOptions({
			maxZoom: 13,
		});
		const bounds = getMapBounds(map, maps, locations);
		map.setCenter(bounds.getCenter());
		_.delay(() => {
			map.fitBounds(bounds, K_BOUNDS_PADDING);
			if (mapRef && mapRef.current) {
				mapRef.current.classList.add(styles.containerInitialized);
			}
			maps.event.addListenerOnce(map, 'idle', function() {
				map.setOptions({
					maxZoom: 999,
				});
			});

		}, 50);
		this.bindMapListeners(map, maps, bounds);
	};

	onMapsAPIReady = (map, maps) => {
		this.googleMaps = maps;
		this.mapInstance = map;
		Popup = definePopupClass(maps);
		this.center(map, maps, this.props.locations);
	};

	onCloseClick = () => {
		this.removePopup();
	};

	getPopupContentFromLocation = (location) => {
		if (!location) {
			return;
		}
		// MapMarker
		const locationTelephone = location.phone;
		const locationTitle = location.title;
		const locationSiteText = I18N.location_link_label;
		const locationSiteUrl = location.link;
		const locationAddressUrl = getMapLinkForLocation(location);
		const locationAddressText = I18N.location_address_label;

		return (
			<div className={styles.popupBubbleContent}>
				<PopupContents
					locationTitle={locationTitle}
					locationTelephone={locationTelephone}
					locationAddressUrl={locationAddressUrl}
					locationAddressText={locationAddressText}
					locationSiteText={locationSiteText}
					locationSiteUrl={locationSiteUrl}
					onCloseClick={this.onCloseClick}
				/>
			</div>
		);
	};

	onMarkerClick = (location) => {
		if (!this.googleMaps) {
			return;
		}
		this.removePopup();
		const position = new this.googleMaps.LatLng(location.lat, location.lng);
		this.currentPopup = new Popup(
			position,
			this.getPopupContentFromLocation(location),
		);
		this.currentPopup.setMap(this.mapInstance);
		const centerOffset = getCenterOffset(this.mapInstance, this.googleMaps, position, 0, -100);
		this.mapInstance.panTo(centerOffset);

	};

	getMarkers = (locations) => {
		return _.map(locations, (location) => {
			const uniqId = _.uniqueId('marker');
			return (
				<MapMarker
					key={uniqId}
					location={location}
					lat={location.lat}
					lng={location.lng}
					onClick={this.onMarkerClick}
				/>
			);
		});
	};

	componentDidUpdate = (prevProps) => {
		if (this.mapInstance && this.googleMaps) {
			this.center(this.mapInstance, this.googleMaps, this.props.locations);
		}
	};

	/**
	 * @function shouldComponentUpdate
	 * @description Only change when the locations is different than the previous. Optimization
	 */
	shouldComponentUpdate = (nextProps) => {
		const first = this.props.locations.length >= nextProps.locations.length ? this.props.locations : nextProps.locations;
		const second = this.props.locations.length >= nextProps.locations.length ? nextProps.locations : this.props.locations;
		const diff = _.differenceWith(first, second, _.isEqual);
		return !_.isEmpty(diff) || diff.length;
	};

	render() {
		this.removePopup();
		const markers = this.getMarkers(this.props.locations);

		return (
			<div className={styles.container} ref={mapRef} >
				<GoogleMapReact
					bootstrapURLKeys={{ key: API_KEY }}
					defaultCenter={defaultProps.center}
					defaultZoom={defaultProps.zoom}
					yesIWantToUseGoogleMapApiInternals
					onGoogleApiLoaded={({ map, maps }) => {this.onMapsAPIReady(map, maps, this.props.locations);}}
				>
					{markers}
				</GoogleMapReact>
			</div>
		);
	}
}

export default Map;


// WEBPACK FOOTER //
// ./src/components/map.js